import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetMeasureListQuery } from '../../api/endpoints/sap';
import { useLanguage } from '../../contexts/LanguageContext';

const SapMeinsDropdown = ({ value, onChange, className = '', disabled = false, placeholder }) => {
    const { getCurrentLanguageId, th } = useLanguage();
    const languageId = getCurrentLanguageId();

    const { data: measureList = [], isLoading } = useGetMeasureListQuery({ languageId });

    const measureOptions = useMemo(() => {
        return measureList.map((item) => {
            // Backend'den gelen alan isimlerine göre mapping
            const code = item.uomCode || item.r || item.code;
            const trDesc = item.trDescription || item.trDescription || item.d;
            const enDesc = item.enDescription || item.enDescription || item.d;
            const description = languageId === 2 ? trDesc : enDesc;
            
            return {
                code: code,
                description: description,
                label: `${code} - ${description}`
            };
        });
    }, [measureList, languageId]);

    return (
        <Dropdown
            value={value}
            onChange={onChange}
            options={measureOptions}
            optionLabel="label"
            optionValue="code"
            placeholder={placeholder || th('externalItemDescription.selectMeins') || 'Select Unit of Measure'}
            className={className}
            disabled={disabled || isLoading}
            filter
            showClear
            loading={isLoading}
        />
    );
};

export default SapMeinsDropdown;

